import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./footer.css";

function Footer() {
  const [showCookieBar, setShowCookieBar] = useState(false);

  // Check if user has already made a cookie choice
  useEffect(() => {
    const cookieChoice = localStorage.getItem('cookieConsent');
    if (!cookieChoice) {
      setShowCookieBar(true);
    } else {
      // Apply the existing choice
      applyCookieSettings(cookieChoice === 'accepted');
    }
  }, []);

  const applyCookieSettings = (acceptAll) => {
    if (window.gtag) {
      // Configure Google Analytics based on consent
      window.gtag('config', 'GA_TRACKING_ID', {
        'anonymize_ip': !acceptAll,
        'allow_google_signals': acceptAll,
        'allow_ad_personalization_signals': acceptAll
      });
    }
  };

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    applyCookieSettings(true);
    setShowCookieBar(false);
  };

  const handleRefuseNonEssential = () => {
    localStorage.setItem('cookieConsent', 'essential-only');
    applyCookieSettings(false);
    setShowCookieBar(false);
  };

  // useEffect(() => {
  //   if (window.FB && window.FB.XFBML) {
  //     window.FB.XFBML.parse();
  //   }
  // }, []);

  return (
    <>
      {/* Cookie Consent Bar */}
      {showCookieBar && (
        <div className="cookie-consent-bar">
          <div className="cookie-content">
            <div className="cookie-text">
              <p>
                <strong>We use cookies to improve your experience.</strong>
              </p>
              <p>
                We use essential cookies to make our site work. We'd also like to set optional analytics cookies to help us improve it. 
                We won't set optional cookies unless you enable them.
              </p>
            </div>
            <div className="cookie-buttons">
              <button 
                className="cookie-btn cookie-btn-accept"
                onClick={handleAcceptAll}
              >
                Accept All Cookies
              </button>
              <button 
                className="cookie-btn cookie-btn-essential"
                onClick={handleRefuseNonEssential}
              >
                Essential Cookies Only
              </button>
            </div>
          </div>
          <button 
            className="cookie-close"
            onClick={handleRefuseNonEssential}
            aria-label="Close cookie banner"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      )}

      <footer id="footer">
        {/* <div
          className="fb-page"
          data-href="https://www.facebook.com/ploughingmatch.co.uk"
          data-tabs="timeline"
          data-width=""
          data-height=""
          data-small-header="true"
          data-adapt-container-width="true"
          data-hide-cover="true"
          data-show-facepile="true"
          data-lazy="true"
        >
          <blockquote
            cite="https://www.facebook.com/ploughingmatch.co.uk"
            className="fb-xfbml-parse-ignore"
          >
            <a href="https://www.facebook.com/ploughingmatch.co.uk">
              FFF&amp;B Ploughing Championships and Country Show
            </a>
          </blockquote>
        </div> */}
        <div className="container">
          <ul className="icons">
            <li>
              <a
                href="https://www.instagram.com/fffbcountryshow"
                title="Instagram"
                className="icon"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
                <span className="label">Instagram</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/ploughingmatch.co.uk"
                title="Facebook"
                className="icon"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faFacebook} />
                <span className="label">Facebook</span>
              </a>
            </li>
            <li>
              <Link to="/contact-us" title="Contact us" className="icon">
                <FontAwesomeIcon icon={faEnvelope} />
                <span className="label">Email</span>
              </Link>
            </li>
          </ul>
        </div>
        <div className="copyright">
          &copy;{new Date().getFullYear()} Fairford, Faringdon, Filkins &
          Burford Ploughing Society. All Rights Reserved.
        </div>
      </footer>
    </>
  );
}

export default Footer;
